export enum ExtensionProviderEnum {
  ORBIFY = "orbify",
  EUDR = "eudr",
}
